import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ChatStyles from '../Chat.module.css';

const Tabs = () => {
  const { t } = useTranslation();
  return (
    <div className={ChatStyles.chatLists_tabs}>
      <Link to='/chat' className={ChatStyles.chatLists_tab_link}>
        {t('screens.chat.tabAllChats')}
      </Link>
      <Link to='/chat-requests' className={[ChatStyles.chatLists_tab_link, ChatStyles.chatLists_tab_link_active].join(' ')}>
        {t('screens.chat.tabChatRequests')}
      </Link>
    </div>
  );
};

export default Tabs;
